angular.module("ainapp")
    .controller("employeeVacationLedgerController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Employee Vacation Ledger";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {


                $scope.load = 0;

            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.EmployeeVacationLedgerInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.LanguageData.NetworkError);
                        })
                    },

                },
                change: function (data) {
                    if (data.items.length > 0) {
                        data.sender._aggregateResult.Balance.count = 0;
                        angular.forEach(data.items, function (e) {
                            e.aggregates.Balance.count = Math.abs(e.aggregates.Credited.sum - e.aggregates.Taken.sum);
                            e.aggregates.Balance.count = Math.round(e.aggregates.Balance.count * 100) / 100;
                        })
                        data.sender._aggregateResult.Balance.count = data.sender._aggregateResult.Credited.sum - data.sender._aggregateResult.Taken.sum;
                        data.sender._aggregateResult.Balance.count = Math.round(data.sender._aggregateResult.Balance.count * 100) / 100;
                    }
                },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "Employee.Name": {
                                type: "string",
                                editable: false,
                            },
                            "VacationRequest.VoucherNumber": {
                                type: "string",
                                editable: false,
                            },
                            "EmployeeSalary.VoucherNumber": {
                                type: "string",
                                editable: false,
                            },
                            Remarks: {
                                type: "string",
                                editable: false,
                            },
                            Credited: {
                                type: "number",
                                editable: false,
                            },
                            Taken: {
                                type: "number",
                                editable: false,
                            },
                            Balance: {
                                type: "number",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },


                        }
                    }
                },

                group: [{
                    field: "Employee.Name",
                    aggregates: [
                        {
                            field: "Credited",
                            aggregate: "sum"
                            },
                        {
                            field: "Taken",
                            aggregate: "sum"
                            },
                        {
                            field: "Balance",
                            aggregate: "count"
                            }
                        ]
                    }],
                aggregate: [{
                        field: "Credited",
                        aggregate: "sum"
                            },
                    {
                        field: "Taken",
                        aggregate: "sum"
                            },
                    {
                        field: "Balance",
                        aggregate: "count"
                            }],

                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "Employee.Name",
                        title: "Employee",
                        hidden: true,
                        headerTemplate: "{{LanguageData.Employee}}",
                        },
                    {
                        field: "VacationRequest.VoucherNumber",
                        title: "Vacation Request",
                        headerTemplate: "{{LanguageData.LeaveType}}",
                        },
                    {
                        field: "EmployeeSalary.VoucherNumber",
                        title: "Employee Salary",
                        headerTemplate: "{{LanguageData.LeaveType}}",
                        },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",                        headerTemplate: "{{LanguageData.Date}}",

                        },
                    {
                        field: "Credited",
                        title: "Credited",
                        template: "<div  style='text-align: right'>#=kendo.toString(Credited, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",

                        },
                    {
                        field: "Taken",
                        title: "Taken",
                        template: "<div  style='text-align: right'>#=kendo.toString(Taken, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",

                        },
                    {
                        field: "Balance",
                        title: "Balance",
                        template: "<div  style='text-align: right'>#=kendo.toString(Balance, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(count, 'n')#",
                        footerTemplate: "#=kendo.toString(count, 'n')#",
                        headerTemplate: "{{LanguageData.Balance}}",
                        },
                    {
                        field: "Remarks",
                        title: "Remarks",
                        },
//                    {
//                        title: "Options",
//                        headerTemplate: "{{LanguageData.Options}}  ",
//                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button>",
//                        width: '80px'
//                    },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

                }])
